import { render, staticRenderFns } from "./communicationDashboardSlideManager.vue?vue&type=template&id=ed497acc&scoped=true"
import script from "./communicationDashboardSlideManager.vue?vue&type=script&lang=js"
export * from "./communicationDashboardSlideManager.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardSlideManager.vue?vue&type=style&index=0&id=ed497acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed497acc",
  null
  
)

export default component.exports